import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import ptBr from '@angular/common/locales/pt';
import {
	ApplicationConfig,
	DEFAULT_CURRENCY_CODE,
	LOCALE_ID,
	inject,
	provideEnvironmentInitializer,
	provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { icons as lucideIcons } from '@iconify-json/lucide';
import { icons as svgSpinners } from '@iconify-json/svg-spinners';
import { addCollection } from '@iconify/iconify';
import { APP_SERVICE, ASSETS, GLOBAL_CONSTANT, SEND_SERVICE, USER_SERVICE } from '@lbca/legacy';
import { claimLabels } from 'assets/labels/components/claim/claimLabels';
import { fieldsLabels } from 'assets/labels/components/fields';
import { maskErrors } from 'assets/labels/feedbacks/masks';
import { SystemFeedbacks } from 'assets/labels/feedbacks/system';
import { TaskFeedbacks } from 'assets/labels/feedbacks/task';
import { dependenceLabels } from 'assets/labels/pages/form/form-dependences';
import { taskLabels } from 'assets/labels/pages/task/taskform';
import { Global } from 'constants/global.const';
import { environment } from 'environments/environment';
import { CommonService } from 'services/common.service';
import { ModalV2Service } from 'services/modalV2.service';
import { SendService } from 'services/send.service';
import { UserService } from 'services/user.services';
import { routes } from './app.routes';
import { AppService } from './app.service';
import { authInterceptor } from './interceptors/auth.interceptor';
import { exceptionInterceptor } from './interceptors/exception.interceptor';
import { refreshTokenInterceptor } from './interceptors/refresh-token.interceptor';
import { timeoutInterceptor } from './interceptors/timeout.interceptor';

registerLocaleData(ptBr);
addCollection(lucideIcons);
addCollection(svgSpinners);

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection(),
		provideHttpClient(
			withFetch(),
			withInterceptors([
				exceptionInterceptor,
				refreshTokenInterceptor,
				authInterceptor,
				timeoutInterceptor,
			]),
		),
		provideRouter(routes, withViewTransitions()),
		provideEnvironmentInitializer(() => {
			inject(ModalV2Service);
		}),
		CommonService,
		{ provide: LOCALE_ID, useValue: 'pt' },
		{ provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
		{ provide: 'googleTagManagerId', useValue: environment.gtmId },
		{ provide: APP_SERVICE, useExisting: AppService },
		{ provide: USER_SERVICE, useExisting: UserService },
		{ provide: SEND_SERVICE, useExisting: SendService },
		{ provide: GLOBAL_CONSTANT, useValue: Global },
		{
			provide: ASSETS,
			useValue: {
				labels: {
					components: {
						fields: fieldsLabels,
						claim: claimLabels,
					},
					pages: {
						task: {
							taskForm: taskLabels,
						},
						form: {
							formDependences: dependenceLabels,
						},
					},
					feedbacks: {
						task: TaskFeedbacks,
						masks: maskErrors,
						system: SystemFeedbacks,
					},
				},
			},
		},
	],
};
